export default {
  'Sales registry': 'Sales registry',
  'Sales registry topbar subtitle': 'Management of products and services',
  'Sales registry subtitle': 'Manage the products and services users can register on the platform.',
  'New product or service': 'New product or service',
  'Creation date': 'Creation date',
  'Product name': 'Product or service name',
  'Payment type': 'Payment type',
  'Default price': 'Default price',
  'Default price optional': 'Default price (optional)',
  'Description optional': 'Description (optional)',
  'One-time payment': 'One-time',
  'Recurring payment': 'Monthly',
  'No description': 'No description',
  'Add first product title': 'Add new product or service',
  'Sales currency intro':
    'Before registering the first product or service, you must set the currency for the account.',
  'Sales currency important': 'IMPORTANT:',
  'Sales currency warning body':
    'The chosen currency will apply to the entire account and cannot be changed later.',
  'Choose currency': 'Choose currency',
  'Sales currency footnote':
    '*This is only shown the first time you create a product or service.',
  'Edit product': 'Edit product or service',
  'Delete product or service': 'Delete product or service',
  'Delete product service confirm':
    'This action cannot be undone.',
  Sales: 'Sales',
  'Add sale': 'Add sale',
  'Add product': 'Add product',
  'Go to catalog': 'Go to catalog',
  'Add product or service': 'Add product or service',
  'Tooltip sale needs catalog admin':
    'Before adding a sale, you must first add a product or service.',
  'Tooltip sale needs catalog staff':
    'Before adding a sale, a manager or administrator must first add a product or service.',
  'Register new sale': 'Register new sale',
  'Save sale': 'Save sale',
  'Note optional': 'Note (optional)',
  Price: 'Price',
  'No sales for client': 'No sales recorded for this contact yet.',
  'Edit sale': 'Edit sale',
  Product: 'Product or service',
  'Removed from catalog': 'removed',
  Amount: 'Amount',
  'Sale date': 'Sale date',
  'Delete sale': 'Delete this sale?',
  'Delete sale confirm': 'This action cannot be undone.',
  'Sales popover intro':
    'Enable sales tracking to start measuring your results in Uniboxi.',
  'Sales popover with sales registry link':
    'To get started, go to Sales registry and create your first product or service.',
  'Sales popover admin required':
    'Only an admin or manager can create products or services. Ask an administrator to do it.',
  salesCountSummary: '{{count}} sales',
  monthAbbr: 'mo',
  monthWord: 'month',
  'Sales metrics': 'Sales metrics',
  'Empty sales metrics title': 'Measure the sales Uniboxi generates for you',
  'Empty sales metrics text 1':
    'Stop guessing. Log sales from WhatsApp, Messenger, and Instagram and see how much you are selling with Uniboxi. Identify which products or services sell most and which users convert more leads into sales.',
  'Empty sales metrics admin note':
    'Only an administrator or manager can enable it.',
  'Empty sales metrics start now': 'Start now',
  'Sales records': 'Sales records',
  Quantity: 'Quantity',
  'Recurring sale': 'Recurring sale',
  'One-time sale': 'One-time sale',
  'Closing rate by user': 'Closing rate by user',
  'Conversations created in period and sales made in those conversations': 'Conversations created in period and sales made in those conversations',
  'Sales count': 'Sales recorded',
  'Total amount': 'Total amount',
  'Closing rate': 'Closing rate',
  'Total sales': 'Total sales',
  'Sales totals': 'Sales',
  'Detail with all sales in filtered period': 'Detail with all sales in filtered period',
  'Client name': 'Client name',
  'Product/service': 'Product/service',
  'Sales summary per user': 'Sales summary per user',
  'Includes all sales in filtered period': 'Includes all sales in filtered period',
};
